exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1tTX-2TBWeQzvVD-3hok8T{max-width:600px!important}.VVMMMUP0DA5anLrGz3upF{font-size:17px;font-weight:300}html[dir] .VVMMMUP0DA5anLrGz3upF{margin-top:10px;margin-bottom:10px}._2hOZz6qv10AN3PKRHUCFo1{width:400px}.Oq9gmMpbRLOzaQYV9lq0m{display:inline-block}", ""]);

// exports
exports.locals = {
	"dialog": "_1tTX-2TBWeQzvVD-3hok8T",
	"title": "VVMMMUP0DA5anLrGz3upF",
	"textbox": "_2hOZz6qv10AN3PKRHUCFo1",
	"spinner": "Oq9gmMpbRLOzaQYV9lq0m"
};